import { createSlice } from "@reduxjs/toolkit";

const addFlightShop = {
    flyFrom: "",
    flyTo: "",
};
const form1Options = {
    yourAirline: [],
    brands: [],
    ota: [],
    meta: [],
    gds: [],
    rateparity:[],
    isAncillary: ["No"],
    // isDeepsearch: ["No"]
};
const form2Options = {
    route: null,
    los: null, // Length of Stay (only visible when "RT" is selected)
    cabinClass: null,
    adults: null,
    infants: null,
    pax: "",
    pos: "",
    currency: "",
    maxStops: "",
    maxDuration: "",
    startDay: null,
    endDay: null,
    startDate: null,
    endDate: null,
    customDay: "",
    history: null,
    historicalHorizon: null,
    horizonDays: [],
};
const form3Options = {
    frequency: "Daily",
    startDate: null,
    weekDays: [],
    monthDays: null,
    monthDaysAdd: [],
    customAdd: [],
    timeZone: "Europe/London",
    time: "",
    deliveryzone: [],
    needEndDate: "No",
    endDate: null,
    shopName: "",
    charts: ["Yes"],
    chartsExist:[]
}

const AddShopSlice = createSlice({
    name: "addShop",
    initialState: {
        addFlightShop,
        form1Options,
        form2Options,
        form3Options
    },
    reducers: {
        setFlightroute(state, action) {
            state.addFlightShop = { ...addFlightShop, ...action.payload }
        },
        setForm1Options(state, action) {
            state.form1Options = { ...form1Options, ...action.payload };
        },
        setForm2Options(state, action) {
            state.form2Options = { ...form2Options, ...action.payload };
        },
        setForm3Options(state, action) {
            state.form3Options = { ...form3Options, ...action.payload };
        },
        resetFormOptions(state) {
            state.addFlightShop = addFlightShop;
            state.form1Options = form1Options;
            state.form2Options = form2Options;
            state.form3Options = form3Options;

        }
    },
});

export const {
    setFlightroute,
    setForm1Options,
    setForm2Options,
    setForm3Options,
    resetFormOptions
} = AddShopSlice.actions;

export default AddShopSlice.reducer;
